import type { TFunction } from 'i18next';

/**
 * The sentence to show for why an import failed: the API's stored `failure_message`, or a generic
 * sentence when it has none, so a failed import never shows an empty line.
 *
 * The API owns the failure sentences (Feathr/anhinga#8512) and stores only customer-safe copy, so
 * the message renders verbatim. The generic sentence is a placeholder until Product supplies final
 * wording.
 */
export function getImportFailureMessage(message: string | null | undefined, t: TFunction): string {
  if (message?.trim()) {
    return message;
  }
  return t('Failed because of a problem with the file. Check the file, then upload it again.');
}
